export default {
  _8Char: 'At least 8 characters',
  _1Capital: 'At least 1 capital letter',
  digits: 'At least 1 digit',
};
